import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import styles from './style.module.scss';
import { Navbar, NavbarToggler, NavItem, NavbarBrand, Container, Nav } from 'reactstrap';
import Logo from '../Logo';
import { withThemeVariant } from '../../provider/ThemeProvider';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import cn from 'classnames';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
export var BaseHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseHeader, _React$Component);

  function BaseHeader(props) {
    var _this;

    _classCallCheck(this, BaseHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseHeader).call(this, props));

    _this.toggleDrawer = function (open) {
      return function () {
        setTimeout(function () {
          this.setState({
            isOpen: open
          });
        }.bind(_assertThisInitialized(_this)), 50);
      };
    };

    _this.handleScroll = function () {
      var affix = _this.state.affix;
      var offset = _this.state.offset;
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (!affix && scrollTop >= offset) {
        _this.setState(_objectSpread({}, _this.state, {
          affix: true
        }));
      }

      if (affix && scrollTop < offset) {
        _this.setState(_objectSpread({}, _this.state, {
          affix: false
        }));
      }
    };

    _this.toggle = function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };

    _this.state = {
      visibile: false,
      affix: false,
      offset: 100,
      isOpen: false
    };
    return _this;
  }
  /**
   * toggle mobile navigation we need the short setTimeOut function
   * as workaround for clicks on buttons
   */


  _createClass(BaseHeader, [{
    key: "componentDidMount",

    /**
     * @return {void}
     */
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
    /**
     * @return {void}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
    /**
     * @return {void}
     */

  }, {
    key: "render",
    value: function render() {
      var _cn;

      return React.createElement("header", null, React.createElement("div", {
        className: styles.navSpacer
      }, React.createElement("div", {
        className: "\n            ".concat(this.props.globalThemeVariant === 'pc' ? this.state.affix ? styles.navWrapperAffixPc : styles.navWrapperPc : styles.navWrapper, "\n            ").concat(styles[this.props.variant])
      }, React.createElement("div", {
        className: styles[this.props.globalThemeVariant]
      }, React.createElement(Navbar, {
        className: styles.mainLayer,
        dark: true,
        expand: "md"
      }, React.createElement(Container, {
        className: cn((_cn = {}, _defineProperty(_cn, styles.mainContainer, true), _defineProperty(_cn, styles.logoLeftMargin, this.props.globalThemeSubVariant === 'news'), _cn))
      }, this.props.children ? this.props.children : React.createElement(NavbarBrand, {
        className: styles.brand,
        title: "TruckJobs",
        href: "/"
      }, React.createElement(Logo, null)), this.props.callToAction && React.createElement("div", {
        className: styles.mobileCta
      }, this.props.callToAction), this.props.globalThemeVariant !== 'pc' && !this.props.noButtons && React.createElement(NavbarToggler, {
        className: styles.toggler,
        onClick: this.toggleDrawer(true)
      })), this.props.nav && React.createElement(Nav, {
        className: "".concat(styles.buttonBar),
        navbar: true
      }, this.props.globalThemeVariant === 'bc' && React.createElement(NavItem, null, React.createElement("div", {
        className: styles.phone
      }, this.props.phone)), this.props.callToAction && React.createElement("li", {
        className: styles.desktopCta
      }, this.props.callToAction), this.props.nav), React.createElement("div", null, React.createElement("div", {
        className: styles.darkLayer
      }), React.createElement("div", {
        className: styles.lightLayerWashed
      }), React.createElement("div", {
        className: styles.darkLayerWashed
      }), React.createElement("div", {
        className: styles.darkLayerWashed2
      }), React.createElement("div", {
        className: styles.lightLayer
      }))))), this.props.mobileNav && this.props.globalThemeVariant !== 'pc' && React.createElement(SwipeableDrawer, {
        className: styles.swipeableDrawerVisible,
        open: this.state.isOpen,
        onClose: this.toggleDrawer(false),
        onOpen: this.toggleDrawer(true)
      }, React.createElement("div", {
        id: "mobileNavDrawe",
        tabIndex: 0,
        className: styles.drawer
      }, React.createElement("div", {
        className: styles.navElm
      }, React.createElement(ClickAwayListener, {
        onClickAway: this.toggleDrawer(false)
      }, this.props.mobileNav))))));
    }
  }]);

  return BaseHeader;
}(React.Component);
BaseHeader.defaultProps = {
  variant: 'default'
};
export default withThemeVariant(BaseHeader);